import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@core/material';
import { TranslateModule } from '@ngx-translate/core';
import { PivotConfirmDialogComponent } from './pivot-confirm-dialog.component';

@NgModule({
  declarations: [PivotConfirmDialogComponent],
  exports: [
    PivotConfirmDialogComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    TranslateModule,
  ],
  entryComponents: [PivotConfirmDialogComponent],
})
export class PivotConfirmDialogModule {
}
